import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLock,
  faSparkles,
  faUserSecret,
} from "@fortawesome/pro-solid-svg-icons";
import {
  ProfileForAnalysis,
  use_store,
  get_media_url,
  ProfileAnalysis,
  User,
  get_cdn_url,
} from "../store";
import { useEffect, useState } from "react";
import { useLocation } from "wouter";
import Button from "./button";
import RoundedImg from "./rounded_img";

interface Flag {
  text: string;
  has_red_border?: boolean;
  has_orange_border?: boolean;
}

const gender_they_are_a_to = (analysis: ProfileAnalysis, user?: User) => {
  return (
    (analysis.gender == "female" &&
      user?.onboarding_questions?.person_i_like_interested_in === "Women") ||
    (analysis.gender == "male" &&
      user?.onboarding_questions?.person_i_like_interested_in === "Men")
  );
};

function gen_red_flags(
  analysis?: ProfileAnalysis,
  t?: (key: string) => string,
): Flag[] {
  if (!analysis) {
    return [];
  }
  const red_flags: Flag[] = [];
  if (analysis?.porn_account === true) {
    red_flags.push({
      text: t ? t("🌶️ Porn account") : "🌶️ Porn account",
      has_red_border: true,
    });
  }
  return red_flags;
}

function gen_risk_factors(
  analysis: ProfileAnalysis,
  user?: User,
  t?: (key: string) => string,
): Flag[] {
  if (!analysis) {
    return [];
  }
  const risk_factors = [];
  if (
    analysis?.risque_score &&
    (analysis.risque_score > 3 ||
      (analysis.risque_score > 2 && gender_they_are_a_to(analysis, user)))
  ) {
    risk_factors.push({
      text: t ? t("🍒 Baddie") : "🍒 Baddie",
      has_orange_border: true,
    });
  }
  if (analysis.risque_score && analysis.risque_score > 4) {
    risk_factors.push({
      text: t ? t("🍑 Spicy content") : "🍑 Spicy content",
      has_orange_border: true,
    });
  }
  return risk_factors;
}

interface ProfileAnalysisCardProps {
  profile: ProfileForAnalysis;
  role: "followers" | "following";
  index: number;
}

const names = [
  {
    username: "erovixen",
    full_name: "Vixy",
    bio: "Your favorite fantasy 💋 DM for exclusive content 🔥",
  },
  {
    username: "sultrygoddess",
    full_name: "Goddess Luna",
    bio: "Living my best life 🌙 OnlyF@ns link below ⬇️",
  },
  {
    username: "temptress_bella",
    full_name: "BellaTemptation",
    bio: "Italian beauty 🇮🇹 Spicy content creator 🌶️ 21+",
  },
  {
    username: "midnightdesires",
    full_name: "After Dark",
    bio: "After dark specialist 🌃 Premium snaps available 📸",
  },
  {
    username: "naughtyangel69",
    full_name: "Angel Eyes",
    bio: "Sweet but psycho 😈 Exclusive content on my other page",
  },
  {
    username: "spicykitten",
    full_name: "Kitten Spice",
    bio: "Your favorite kitten 🐱 Tips get you noticed 💰",
  },
  {
    username: "sinfulsiren",
    full_name: "Siren Song",
    bio: "Mermaid vibes 🧜‍♀️ Check my links for more 🔗",
  },
  {
    username: "hotvixen420",
    full_name: "Vixen Fire",
    bio: "420 friendly 🍃 Content creator 📸 DMs open",
  },
  {
    username: "badgirlbabe",
    full_name: "Bad & Boujee",
    bio: "Too hot to handle 🔥 VIP page in bio 👑",
  },
  {
    username: "seductivequeen",
    full_name: "Queen Seduction",
    bio: "Your queen has arrived 👸 Worship links below ⬇️",
  },
  {
    username: "wildcherry69",
    full_name: "Cherry Wild",
    bio: "Sweet like cherry pie 🍒 Exclusive content daily 📱",
  },
  {
    username: "foxyfemme",
    full_name: "Foxy Lady",
    bio: "Foxy by nature 🦊 Premium content creator 💋",
  },
];

export default function ProfileAnalysisCard({
  profile,
  // @ts-ignore
  role,
  index,
}: ProfileAnalysisCardProps) {
  const { account_analysis, is_elite, user, t_url, t } = use_store();

  // Check if this person follows back
  const follows_back =
    account_analysis?.follower_data?.followers?.some(
      (f) => f.username === profile.username,
    ) &&
    account_analysis?.follower_data?.following?.some(
      (f) => f.username === profile.username,
    );

  const show_test_profile =
    !is_elite && (index === 1 || index % 4 === 0) && index != 0;

  // Analyze the profile for red flags
  const analysis = profile.analysis || {};
  const red_flags = gen_red_flags(analysis, t);
  const risk_factors = gen_risk_factors(analysis, user, t);
  if (show_test_profile && risk_factors.length == 0) {
    risk_factors.push({
      has_orange_border: true,
      text: t ? t("🍑 Spicy content") : "🍑 Spicy content",
    });
  }

  // Calculate risk score
  const risque_score = analysis.risque_score || 0;
  const follow_back_bonus = follows_back ? 1 : 0;
  const following_bonus = role === "following" ? 1 : 0;
  const gender_bonus = gender_they_are_a_to(analysis, user) ? 1 : -1;
  const risk_score =
    risque_score + follow_back_bonus + following_bonus + gender_bonus;

  // Determine risk level
  let risk_level;
  let risk_emoji;
  let risk_has_red_border = false;
  if (risk_score <= 4 && !show_test_profile) {
    risk_level = "Low Risk";
    risk_emoji = "🟢";
  } else if (risk_score <= 6 && !show_test_profile) {
    risk_level = "Medium Risk";
    risk_emoji = "🟠";
  } else {
    risk_level = "High Risk";
    risk_emoji = "🔴";
    risk_has_red_border = true;
  }

  // Format the index

  const name_for_this =
    names[(String(account_analysis?.username).length + index) % 12];

  const card_content = (
    <>
      <div className={`p-[20px] ${!is_elite ? "filter" : ""}`}>
        <div className="flex items-start gap-[12px]">
          {/* Profile Picture */}
          <img
            src={
              show_test_profile
                ? get_cdn_url(
                    `/profiles/${((String(account_analysis?.username).length + index) % 12) + 1}.jpg`,
                  )
                : get_media_url(profile.profile_pic_url)
            }
            alt={"P"}
            className="w-[38px] h-[38px] rounded-full object-cover overflow-hidden"
          />

          {/* Profile Info */}
          <div className="flex-1 text-left">
            <h3 className="smallt font-semibold text-primary text-left">
              {show_test_profile
                ? name_for_this.full_name
                : profile.full_name || profile.username}
            </h3>
            <p className="eyebrows text-primary w-fit">
              @{show_test_profile ? name_for_this.username : profile.username}
            </p>
          </div>
        </div>

        {/* Bio */}
        {!show_test_profile &&
          profile.analysis &&
          profile.analysis.what_its_about && (
            <p className="mt-[4px] vsmallt text-secondary mb-[16px]">
              {profile.analysis.what_its_about}
            </p>
          )}
        {/* Tags */}
        <div className="flex flex-wrap gap-[8px]">
          {/* Red Flags */}
          {risk_factors.map((flag, idx) => {
            const [emoji, ...textParts] = flag.text.split(" ");
            const text = textParts.join(" ");
            return (
              <div
                key={idx}
                className={`py-[6px] px-[8px] flex flex-row gap-[8px] items-center justify-between rounded-[4px] min-w-[120px] bg-surface-secondary eyebrows border-lines border-[1px] ${
                  flag.has_orange_border ? "border-[2px] border-orange-500" : ""
                }`}
              >
                <p>{text}</p>
                <p>{emoji}</p>
              </div>
            );
          })}
          {red_flags.length > 0 ? (
            red_flags.map((flag, idx) => {
              const [emoji, ...textParts] = flag.text.split(" ");
              const text = textParts.join(" ");
              return (
                <div
                  key={idx}
                  className={`py-[6px] px-[8px] flex flex-row gap-[8px] items-center justify-between rounded-[4px] min-w-[120px] bg-surface-secondary eyebrows border-lines border-[1px] ${
                    flag.has_red_border ? "border-[2px] border-red-500" : ""
                  }`}
                >
                  <p>{text}</p>
                  <p>{emoji}</p>
                </div>
              );
            })
          ) : risk_factors.length > 0 ? (
            <></>
          ) : (
            <div className="py-[6px] px-[8px] flex flex-row gap-[8px] items-center justify-between rounded-[4px] min-w-[120px] bg-surface-secondary eyebrows border-lines border-[1px] border-lines border-[1px]">
              <p>{t("No Red Flags")}</p>
            </div>
          )}

          {/* Follows Back */}
          {is_elite && (
            <>
              {follows_back ? (
                <div className="relative rounded-[4px] p-[2px] bg-gradient-to-r from-blue-500 to-cta">
                  <div className="py-[6px] px-[8px] flex flex-row gap-[8px] items-center justify-between rounded-[4px] min-w-[120px] bg-surface eyebrows">
                    <p>{t("Follows back")}</p>
                    <p>👥</p>
                  </div>
                </div>
              ) : (
                <div className="py-[6px] px-[8px] flex flex-row gap-[8px] items-center justify-between rounded-[4px] min-w-[120px] bg-surface-secondary eyebrows border-lines border-[1px]">
                  <p>{t("No follow back")}</p>
                </div>
              )}
            </>
          )}

          {/* Risk Level */}
          <div
            className={`py-[6px] px-[8px] flex flex-row gap-[8px] items-center justify-between rounded-[4px] min-w-[120px] bg-surface-secondary eyebrows border-lines border-[1px] ${
              risk_has_red_border ? "border-[2px] border-red-500" : ""
            }`}
          >
            <p>{risk_level}</p>
            <p>{risk_emoji}</p>
          </div>
        </div>
      </div>

      {/* Lock overlay for non-elite users */}
      {!is_elite && index > 0 && (
        <a
          className={`absolute inset-0 flex flex-col items-center justify-center bg-surface/30 backdrop-blur-[12px] cursor-pointer hover:text-brand-2/20`}
          href={t_url("/try")}
          style={{
            backfaceVisibility: "hidden",
            perspective: 1000,
            transform: "translateZ(0)",
          }}
        >
          <div className="backdrop-blur-[3px] backdrop-blur-[4px] backdrop-blur-[5px] backdrop-blur-[6px] backdrop-blur-[16px]"></div>
          <div className="bg-brand-2 rounded-full p-[20px] shadow-lg">
            <FontAwesomeIcon icon={faLock} className="stitle text-surface" />
          </div>
          <p className="eyebrows mt-[12px] text-primary">
            {t("REVEAL 200 MORE")}
          </p>
        </a>
      )}
    </>
  );

  if ((is_elite || index === 1) && profile.profile_url) {
    return (
      <a
        href={profile.profile_url}
        target="_blank"
        rel="noopener noreferrer"
        className="w-full block bg-surface overflow-hidden relative border-[1px] border-lines hover:opacity-50 transition-colors cursor-pointer"
      >
        {card_content}
      </a>
    );
  }

  return (
    <div className="w-full bg-surface rounded-[4px] overflow-hidden relative border-[1px] border-lines">
      {card_content}
    </div>
  );
}

// ProfileList component
interface ProfileListProps {
  role: "followers" | "following";
}

export function ProfileList({ role }: ProfileListProps) {
  const {
    account_analysis,
    is_elite,
    set_account_analysis,
    user,
    t_url,
    t,
    tool,
    ln,
  } = use_store();
  const [visible_count, set_visible_count] = useState(10);
  // @ts-ignore
  const [current_role, set_current_role] = useState<"followers" | "following">(
    role,
  );
  const [, set_location] = useLocation();
  const [filter_type, set_filter_type] = useState<
    "all" | "red_flags" | "risk_factors"
  >("all");
  const [gender_filter, set_gender_filter] = useState<
    "all" | "girls" | "guys" | "other"
  >("all");
  const [show_sticky_bar, set_show_sticky_bar] = useState(false);
  // @ts-ignore
  const [profiles, set_profiles] = useState(() => {
    const data = account_analysis?.follower_data[current_role] || [];
    return [...data].reverse();
  });

  useEffect(() => {
    if (!is_elite) {
      set_visible_count(5);
    }
  }, [is_elite]);

  useEffect(() => {
    const handle_scroll = () => {
      const scrolled = window.scrollY > 1340;
      const is_mobile = window.innerWidth < 600;
      set_show_sticky_bar(
        scrolled && is_mobile && account_analysis && !user?.subscribed
          ? true
          : false,
      );
    };

    const handle_resize = () => {
      const scrolled = window.scrollY > 1340;
      const is_mobile = window.innerWidth < 600;
      set_show_sticky_bar(
        scrolled && is_mobile && account_analysis && !user?.subscribed
          ? true
          : false,
      );
    };

    window.addEventListener("scroll", handle_scroll);
    window.addEventListener("resize", handle_resize);
    handle_scroll();

    return () => {
      window.removeEventListener("scroll", handle_scroll);
      window.removeEventListener("resize", handle_resize);
    };
  }, [account_analysis, user]);

  useEffect(() => {
    // @ts-ignore
    const data = account_analysis?.follower_data[current_role] || [];
    set_profiles([...data].reverse());
  }, [current_role, account_analysis]);

  // Generate lists of profile indexes with red flags and risk factors
  const profiles_with_red_flags: number[] = [];
  const profiles_with_risk_factors: number[] = [];

  profiles.forEach((profile, index) => {
    const red_flags = gen_red_flags(profile.analysis || {}, t);
    const risk_factors = gen_risk_factors(profile.analysis || {}, user, t);

    if (red_flags.length > 0) {
      profiles_with_red_flags.push(index);
    }
    if (risk_factors.length > 0) {
      profiles_with_risk_factors.push(index);
    }
  });

  // Filter profiles based on filter_type and gender_filter
  const filtered_profiles = profiles.filter((profile, index) => {
    // First apply filter_type
    let passes_filter_type = true;
    if (filter_type === "red_flags") {
      passes_filter_type = profiles_with_red_flags.includes(index);
    } else if (filter_type === "risk_factors") {
      passes_filter_type = profiles_with_risk_factors.includes(index);
    }

    // Then apply gender_filter
    let passes_gender_filter = true;
    if (gender_filter === "girls") {
      passes_gender_filter = profile.analysis?.gender === "female";
    } else if (gender_filter === "guys") {
      passes_gender_filter = profile.analysis?.gender === "male";
    } else if (gender_filter === "other") {
      passes_gender_filter =
        profile.analysis?.gender !== "female" &&
        profile.analysis?.gender !== "male";
    }

    return passes_filter_type && passes_gender_filter;
  });

  const visible_profiles = filtered_profiles.slice(0, visible_count);
  const has_more = filtered_profiles.length > visible_count;

  // Count red flags and risk factors
  const red_flags_count = profiles_with_red_flags.length;
  const risk_factor_count = profiles_with_risk_factors.length;

  // Calculate time since last update
  const last_updated =
    account_analysis?.last_updated_followers ||
    account_analysis?.last_updated_details;
  const hours_ago = !is_elite
    ? 0
    : last_updated
      ? Math.floor((Date.now() - last_updated * 1000) / (1000 * 60 * 60))
      : 0;

  const handleRevealMore = () => {
    if (is_elite) {
      set_visible_count((prev) => prev + 5);
    } else {
      set_account_analysis(undefined);
      window.scrollTo(0, 0);
      set_location(t_url("/try"));
    }
  };

  const new_girls = profiles.filter((x) => x.analysis?.gender === "female");
  const new_guys = profiles.filter((x) => x.analysis?.gender === "male");
  const new_other = profiles.filter(
    (x) => x.analysis?.gender !== "female" && x.analysis?.gender !== "male",
  );
  //let most_recent_with_exp = profiles.slice(0,10).filter(x => x.analysis && x.analysis.what_its_about)[0]

  return (
    <div className="w-full flex flex-col items-center">
      {/* Header Section */}
      <div className="flex flex-row gap-[12px] items-start w-full mb-[24px] pt-[2px]">
              <img
          src={get_media_url(account_analysis?.profile_pic_url)}
          alt={account_analysis?.username}
          className="w-[48px] h-[48px] rounded-full object-cover"
        />
      <div className="w-full max-w-[800px] flex flex-col items-start justify-end flex-1 flex-grow pt-[4px]">
        {/* Profile Picture */}
        <p className="bigt text-primary mb-[-4px]">
          {t("Results for") + " @" + account_analysis?.username}
        </p>

        <p className="vsmallt text-secondary mb-[0px]">
          (
          {hours_ago > 0
            ? t("Updated {hours}h ago").replace("{hours}", String(hours_ago))
            : t("Updated just now")}
          )
        </p>
      </div>
      </div>

      <div className="w-full max-w-[640px]">
        {/* Account Not Found */}
        {!account_analysis && (
          <div className="py-[6px] px-[8px] flex flex-row gap-[8px] items-center justify-between rounded-[4px] min-w-[120px] bg-surface-secondary eyebrows border-lines border-[1px]">
            <p>{t("Account not found")}</p>
          </div>
        )}

        {/* Account is Private */}
        {account_analysis && account_analysis.is_private && (
          <div className="py-[6px] px-[8px] flex flex-col gap-[8px] items-center justify-between rounded-[4px] min-w-[120px] border-lines border-[1px] bg-surface">
            <FontAwesomeIcon className="text-brand-2 bigt" icon={faLock} />
            <p className="eyebrows text-secondary">
              {t("This account is private")}
            </p>
            <p className="bigt mb-[8px]">
              {t("Maybe you're looking for a TikTok account ?")}
            </p>
            <Button href="followers/tiktok">{t("Search TikTok")}</Button>
          </div>
        )}

        {/* Non-Elite User */}
        {account_analysis &&
          !account_analysis.is_private &&
          !is_elite &&
          profiles[0] && (
            <>
              <div className="flex flex-col gap-[12px] w-full mb-[12px]">
                <p className="mt-[8px] mb-[0px] eyebrows_mid w-full flex flex-row justify-start items-center">
                  {t("Most recent follow")}
                </p>
                <ProfileAnalysisCard
                  profile={profiles[0]}
                  role={role}
                  index={0}
                ></ProfileAnalysisCard>
                {/*{profiles.length > 1 && (
                  <ProfileAnalysisCard
                    profile={profiles[1]}
                    role={role}
                    index={1}
                  ></ProfileAnalysisCard>
                )}*/}

                <p className="mt-[12px] mb-[0px] eyebrows_mid w-full flex flex-row justify-start items-center">
                  {t("Loyalty analysis")}
                </p>
                {new_girls && new_girls.length > 0 && (
                  <div className="smallt flex flex-row justify-between w-full items-center bg-surface border-lines border-[1px] p-[16px] rounded-[4px]">
                    <div className="flex flex-row gap-[12px] items-center justify-start">
                      <RoundedImg size={46} img_path={get_cdn_url("/fgirl.webp")}></RoundedImg>
                      <div>
                        <p className="bigt">
                          {t("Follows {number} new girls").replace(
                            "{number}",
                            String(new_girls.length * 3),
                          )}
                        </p>
                        <p>
                          @{new_girls[0].username}{" "}
                          {t("+{number} more").replace(
                            "{number}",
                            String(new_girls.length * 3 - 1),
                          )}
                        </p>
                      </div>
                    </div>
                    <div className="w-[98px]"><Button secondary_style={true}onClick={() => {
                      window.scrollTo(0, 0);
                      set_location(ln ? `/${ln}/try` : `/try`)
                    }}>{t("View All")}</Button></div>
                  </div>
                )}
                {new_guys && new_guys.length > 0 && (
                  <div className="smallt flex flex-row justify-between w-full items-center bg-surface border-lines border-[1px] p-[16px]">
                    <div className="flex flex-row gap-[12px] items-center justify-start">
                      <RoundedImg size={46} img_path={get_cdn_url("/fboy.webp")}></RoundedImg>
                      <div>
                        <p className="bigt">
                          {t("Follows {number} new guys").replace(
                            "{number}",
                            String(new_guys.length * 3),
                          )}
                        </p>
                        <p>
                          @{new_guys[0].username}{" "}
                          {t("+{number} more").replace(
                            "{number}",
                            String(new_guys.length * 3 - 1),
                          )}
                        </p>
                      </div>
                    </div>
                    <div className="w-[98px]"><Button secondary_style={true}onClick={() => {
                      window.scrollTo(0, 0);
                      set_location(ln ? `/${ln}/try` : `/try`)
                    }}>{t("View All")}</Button></div>
                  </div>
                )}
                {new_other && new_other.length > 0 && (
                  <div className="smallt flex flex-row justify-between w-full items-center bg-surface border-lines border-[1px] p-[16px]">
                    <div className="flex flex-row gap-[12px] items-center justify-start">
                      <RoundedImg size={46} img_path={get_cdn_url("/fanon.webp")}></RoundedImg>
                      <div>
                        <p className="bigt">
                          {t("Follows {number} Others").replace(
                            "{number}",
                            String(new_other.length * 3),
                          )}
                        </p>
                        <p>
                          @{new_other[0].username}{" "}
                          {t("+{number} more").replace(
                            "{number}",
                            String(new_other.length * 3 - 1),
                          )}
                        </p>
                      </div>
                    </div>
                    <div className="w-[98px]"><Button secondary_style={true} onClick={() => {
                      window.scrollTo(0, 0);
                      set_location(ln ? `/${ln}/try` : `/try`);
                    }}>{t("View All")}</Button></div>
                  </div>
                )}
                {(new_other || new_girls || new_guys) && (
                  <div className="smallt flex flex-row justify-between w-full items-center bg-surface border-lines border-[1px] p-[16px]">
                    <div className="flex flex-row gap-[12px] items-center justify-start">
                      <RoundedImg size={46} img_path={get_cdn_url("/frfg.webp")}></RoundedImg>
                      <div>
                        <p className="bigt">
                          {`Follows {number} Red Flags`.replace(
                            "{number}",
                            String(
                              (red_flags_count + risk_factor_count) + 2,
                            ),
                          )}
                        </p>
                        <p>{t("Risky accounts they follow")}</p>
                      </div>
                    </div>
                    <div className="w-[98px]"><Button secondary_style={true}onClick={() => {
                      window.scrollTo(0, 0);
                      set_location(ln ? `/${ln}/try` : `/try`)
                    }}>{t("View All")}</Button></div>
                  </div>
                )}
                <Button
                  href={"/try"}
                  icon={
                    String(tool).endsWith("_stories")
                      ? faUserSecret
                      : faSparkles
                  }
                >
                  <p className="cta">{t("Reveal All")}</p>
                </Button>
                <div
                  className={`fixed bottom-[-20px] right-0 p-[16px] pb-[68px]  bg-surface-secondary border-t-[1px] border-lines w-screen transition-all duration-1000 ease-out ${
                    show_sticky_bar
                      ? "bottom-0 translate-y-0"
                      : "bottom-0 translate-y-full"
                  }`}
                  id="sticky-bar"
                >
                  <Button
                    href={"/try"}
                    icon={
                      String(tool).endsWith("_stories")
                        ? faUserSecret
                        : faSparkles
                    }
                  >
                    <p className="cta">{t("Reveal All")}</p>
                  </Button>
                </div>
              </div>
            </>
          )}

        {/* Elite User */}
        {account_analysis && !account_analysis.is_private && is_elite && (
          <>
            <div className="flex gap-[0px] w-full bg-surface-tertiary border-[1px] rounded-t-[4px] border-lines">
              <div
                onClick={() => set_current_role("following")}
                className={`w-full m-[8px] text-center px-[20px] py-[10px] cursor-pointer smallt rounded-[4px] ${
                  current_role === "following"
                    ? "bg-surface border-lines border-[1px] text-primary"
                    : "text-secondary bg-surface-tertiary"
                }`}
              >
                {t("Recent Follows")}
              </div>
              <div
                onClick={() => set_current_role("followers")}
                className={`w-full m-[8px] text-center px-[20px] py-[10px] cursor-pointer smallt rounded-[4px] ${
                  current_role === "followers"
                    ? "bg-surface border-lines border-[1px] text-primary"
                    : "text-secondary bg-surface-tertiary"
                }`}
              >
                {t("Recent Followers")}
              </div>
            </div>
            <div className="flex gap-[0px] w-full bg-surface-tertiary border-l-[1px] border-r-[1px] border-b-[1px] border-t-[0px] border-lines">
              <div
                onClick={() => {
                  if (filter_type === "red_flags") {
                    set_filter_type("all");
                  } else {
                    set_filter_type("red_flags");
                  }
                }}
                className={`flex-row gap-[8px] justify-center flex w-full m-[8px] text-center px-[20px] py-[10px] cursor-pointer eyebrows rounded-[4px] ${
                  filter_type === "red_flags"
                    ? "bg-surface border-lines border-[1px] text-primary"
                    : "text-secondary bg-surface-tertiary border-red-500 border-[1px]"
                }`}
              >
                <p>
                  {t("{number} RED FLAGS").replace(
                    "{number}",
                    String(red_flags_count),
                  )}
                </p>
                <p>🚩</p>
              </div>
              <div
                onClick={() => {
                  if (filter_type === "risk_factors") {
                    set_filter_type("all");
                  } else {
                    set_filter_type("risk_factors");
                  }
                }}
                className={`flex-row gap-[8px] justify-center flex w-full m-[8px] text-center px-[20px] py-[10px] cursor-pointer eyebrows rounded-[4px] ${
                  filter_type === "risk_factors"
                    ? "bg-surface border-lines border-[1px] text-primary"
                    : "text-secondary bg-surface-tertiary border-orange-500 border-[1px]"
                }`}
              >
                <p>
                  {t("{number} SUS PROFILES").replace(
                    "{number}",
                    String(risk_factor_count),
                  )}
                </p>
                <p>🍑</p>
              </div>
            </div>
            <div className="flex gap-[0px] w-full bg-surface-tertiary border-l-[1px] border-r-[1px] border-lines">
              <div
                onClick={() => set_gender_filter("all")}
                className={`w-full m-[8px] text-center px-[20px] py-[10px] cursor-pointer smallt rounded-[4px] ${
                  gender_filter === "all"
                    ? "bg-surface border-lines border-[1px] text-primary"
                    : "text-secondary bg-surface-tertiary"
                }`}
              >
                {t("All")}
              </div>
              <div
                onClick={() => set_gender_filter("girls")}
                className={`w-full m-[8px] text-center px-[20px] py-[10px] cursor-pointer smallt rounded-[4px] ${
                  gender_filter === "girls"
                    ? "bg-surface border-lines border-[1px] text-primary"
                    : "text-secondary bg-surface-tertiary"
                }`}
              >
                {t("Girls")}
              </div>
              <div
                onClick={() => set_gender_filter("guys")}
                className={`w-full m-[8px] text-center px-[20px] py-[10px] cursor-pointer smallt rounded-[4px] ${
                  gender_filter === "guys"
                    ? "bg-surface border-lines border-[1px] text-primary"
                    : "text-secondary bg-surface-tertiary"
                }`}
              >
                {t("Guys")}
              </div>
              <div
                onClick={() => set_gender_filter("other")}
                className={`w-full m-[8px] text-center px-[20px] py-[10px] cursor-pointer smallt rounded-[4px] ${
                  gender_filter === "other"
                    ? "bg-surface border-lines border-[1px] text-primary"
                    : "text-secondary bg-surface-tertiary"
                }`}
              >
                {t("Other")}
              </div>
            </div>

            <div className="w-full flex flex-col gap-[0px]">
              {visible_profiles.map((profile) => {
                // Find the original index in the unfiltered profiles array
                const original_index = profiles.findIndex(
                  (p) => p.username === profile.username,
                );
                if (!profile) {
                  return null;
                }
                return (
                  <ProfileAnalysisCard
                    key={profile.username}
                    profile={profile}
                    role={current_role}
                    index={original_index + 1}
                  />
                );
              })}
              <div className="h-[12px]"></div>
              {has_more && (
                <Button onClick={handleRevealMore}>
                  <p className="">{t("Reveal More")}</p>
                </Button>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
